<template>
  <div class="radio-inputs-payment">
    <label
      class="radio-inputs-payment__option"
      v-for="(option, index) in options"
      :key="index"
      :for="`radio-${name}-${option.value}`"
      tabindex="0"
      @keydown="handleKeyDownLabel"
    >
      <div
        v-if="option.value !== 'INVOICE' || b2bEnabled"
      >
        <input
          v-if="editable"
          class="radio-inputs-payment__input"
          :name="name"
          type="radio"
          v-model="selectedOption"
          :value="option.value"
          :id="`radio-${name}-${option.value}`"
          :disabled="(!invoiceAllowed && option.value === 'INVOICE' && (!guest || !b2bEnabled))"
        >
        <span class="radio-inputs-payment__radio-circle" />

        <div
          v-if="(!invoiceAllowed && option.value === 'INVOICE' && (!guest || !b2bEnabled))"
          class="radio-inputs-payment__option-disabled"
        >
          <span class="radio-inputs-payment__option-name">{{ option.name }}</span>
          <span class="radio-inputs-payment__option-description">{{ option.disabledDescription }}</span>
        </div>
        <div
          v-else
          class="radio-inputs-payment__option-content"
        >
          <span class="radio-inputs-payment__option-name">{{ option.name }}</span>
          <div
            v-if="!invoiceAllowed && option.value === 'INVOICE' && guest && b2bEnabled"
            class="radio-inputs-payment__option-description"
          >
            <guest-checkout-password
              v-if="selectedOption === 'INVOICE'"
              :selected-option="selectedOption"
              :guest="guest"
            >
              {{ option.guestDescription }}
            </guest-checkout-password>
          </div>

          <span
            v-else
            class="radio-inputs-payment__option-description"
          >{{ option.description }}</span>
          <div v-if="option.value === 'CREDIT_CARD'">
            <div v-if="selectedOption === 'CREDIT_CARD'">
              <creditcard :init-step-model="payoneData" />
            </div>
          </div>
        </div>
      </div>
    </label>
  </div>
</template>
<script>
import creditcard from '../creditCard/creditCard.vue'
import GuestCheckoutPassword from '../guestCheckoutPassword/guestCheckoutPassword.vue'

export default {
  components: {
    creditcard,
    GuestCheckoutPassword
  },
  props: {
    options: {
      type: Array,
      default() {
        return []
      }
    },
    editable: {
      type: Boolean,
      default: true,
    },
    name: String,
    initialSelectedOption: String,
    payoneData: {
      type: Object,
      default: {}
    },
    guest: {
      type: Boolean,
      default: false
    },
    invoiceAllowed: {
      type: Boolean,
      default: false
    },
    b2bEnabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedOption: this.initialSelectedOption
    }
  },
  methods: {
    handleKeyDownLabel(event) {
      if (event.key === 'Enter' || event.code === 'Space') {
        event.preventDefault();
        const targetInput = document.getElementById(event.target.getAttribute('for'));
        if (targetInput) {
          targetInput.click();
        }
      }
    }
  }
}

</script>
